import * as R from 'ramda'

import {
  gakkiNameType,
  isGakkiName,
  isWeekDays,
  notGakkiNamesType,
  ryoiki,
  weekAndOtherType,
  yojigen,
} from '../@types/timetable'

export const createTimeTableInitialObject = (): ryoiki => {
  const typeYojigenInitValue: yojigen = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    over: [],
  }
  // const typeGakkiInitValue: weekType = {
  const typeGakkiInitValue: weekAndOtherType = {
    月: R.clone(typeYojigenInitValue),
    火: R.clone(typeYojigenInitValue),
    水: R.clone(typeYojigenInitValue),
    木: R.clone(typeYojigenInitValue),
    金: R.clone(typeYojigenInitValue),
    土: R.clone(typeYojigenInitValue),
    指定なし: [],
  }

  // const typeNenjiInitValue: nenji = {
  const typeRyoikiInitValue: ryoiki = {
    春A: R.clone(typeGakkiInitValue),
    春B: R.clone(typeGakkiInitValue),
    春C: R.clone(typeGakkiInitValue),
    秋A: R.clone(typeGakkiInitValue),
    秋B: R.clone(typeGakkiInitValue),
    秋C: R.clone(typeGakkiInitValue),
    // 夏季休業中: R.clone(typeGakkiInitValue),
    // 通年: R.clone(typeGakkiInitValue),
    // その他: R.clone(typeGakkiInitValue),
    その他: [],
  }

  // const typeRyoikiInitValue: ryoiki = {
  //   1: typeNenjiInitValue,
  //   2: typeNenjiInitValue,
  //   3: typeNenjiInitValue,
  //   4: typeNenjiInitValue,
  // }

  return typeRyoikiInitValue
}

// 実施学期の揺れを正す
// export const yureStringToGakkis = (yureGakki: string): gakkiNameType[] => {
export const yureStringToGakkis = (
  yureGakki: string
): (gakkiNameType | notGakkiNamesType)[] => {
  // yureGakki = yureGakki.replace(/\n/g, '')
  // yureGakki = yureGakki.replace(/A-C/g, 'ABC')
  // yureGakki = yureGakki.replace(/春学期/g, '春ABC')
  // yureGakki = yureGakki.replace(/秋学期/g, '秋ABC')
  // yureGakki = yureGakki.replace(/通年/g, '春ABC秋ABC')
  // yureGakki = yureGakki.replace(/夏季休業中/g, '夏')

  // let targetString = yureGakki
  let targetString = yureGakki

  targetString = targetString.replace(/\n/g, '')
  targetString = targetString.replace(/A-C/g, 'ABC')
  targetString = targetString.replace(/春学期/g, '春ABC')
  targetString = targetString.replace(/秋学期/g, '秋ABC')
  // https://github.com/noenoe/ut_timetable/issues/10#issuecomment-1869391970 通年は本当は夏季休業も含むらしい
  targetString = targetString.replace(/通年/g, '春ABC秋ABC')
  // targetString = targetString.replace(/通年/g, '通')
  targetString = targetString.replace(/夏季休業中/g, '夏')

  if (
    ['要件', '芸術専門学群', 'undefined', '実施学期'].includes(targetString)
  ) {
    targetString = ''
  }

  // const results: gakkiNameType[] = []
  // const results: gakkiNameType[] = []
  // const results: gakkiNameType[] = []
  const results: (gakkiNameType | notGakkiNamesType)[] = []

  for (let i = 0; i < targetString.length; i++) {
    const char = targetString[i]
    if (char === '夏') {
      results.push('その他')
    }
    if (char === '通') {
      results.push('その他')
    }
    if (['春', '秋'].includes(char)) {
      for (let j = i + 1; j < targetString.length; j++) {
        if (['A', 'B', 'C'].includes(targetString[j])) {
          const gakkiString = char + targetString[j]

          if (isGakkiName(gakkiString)) {
            results.push(gakkiString)
          } else {
            console.error(gakkiString)
          }
          i++
        } else {
          break
        }
      }
    }
  }

  return results
}
// 1-4 2-4 1-3
export const yureStringToGakunen = (yureGakunen: string): number[] => {
  let targetString = yureGakunen

  if (['標準履修年次', 'undefined', undefined].includes(targetString)) {
    targetString = ''
  }
  let results: number[] = []
  // yureGakunen = yureGakunen.split(' ').join('')
  targetString = targetString.split(' ').join('')

  const num = Number(targetString)
  if (isNaN(num)) {
    //
    // console.log('揺れ処理')

    // if (yureGakunen.includes('-')) {
    if (targetString.includes('-')) {
      // TODO:
      // const splitedGakunen = yureGakunen.split('-')
      const splitedGakunen = targetString.split('-')
      // FIXME: したと共通化できる？
      const diff = Number(splitedGakunen[1]) - Number(splitedGakunen[0])

      results = R.times(r => {
        return r + Number(splitedGakunen[0])
      }, diff + 1)
    }

    // if (yureGakunen.includes('・')) {
    if (targetString.includes('・')) {
      // const splitedGakunen = yureGakunen.split('・')
      const splitedGakunen = targetString.split('・')
      splitedGakunen.forEach(g => {
        results.push(Number(g))
      })
    }
    //
  } else {
    results.push(num)
  }

  return results
}

export const yureStringToYojigen = (yureYojigen: string): string[] => {
  // TODO:
  // console.log('input', yureYojigen)

  let targetString = yureYojigen

  targetString = targetString.replace(/\n/g, '')
  targetString = targetString.replace(/,/g, '')
  targetString = targetString.replace(/・/g, '')
  targetString = targetString.replace(/応談/g, '応')
  targetString = targetString.replace(/集中/g, '集')
  targetString = targetString.replace(/随時/g, '随')

  if (['曜時限', 'undefined', ''].includes(targetString)) {
    return []
  }

  // 集中・随時・応談

  const results: string[] = []

  for (let i = 0; i < targetString.length; i++) {
    const char = targetString[i]
    // console.log(char)
    if (char === '集') {
      results.push('集中')
    }
    if (char === '随') {
      results.push('随時')
    }
    if (char === '応') {
      results.push('応談')
    }
    //
    //
    if (isWeekDays(char)) {
      //
      const sequentialYoubiChars = getSequentialWeekdaysString(
        targetString.slice(i)
      )
      //
      // for (let j = i + 1; j < targetString.length; j++) {
      for (
        let j = i + sequentialYoubiChars.length;
        j < targetString.length;
        j++
      ) {
        if (['1', '2', '3', '4', '5', '6'].includes(targetString[j])) {
          R.split('', sequentialYoubiChars).forEach(ccc => {
            results.push(ccc + targetString[j])
          })
          i++
        } else if (['-'].includes(targetString[j])) {
          // 1-3のような範囲指定を処理
          const largerNum = Number(targetString[j + 1])
          const smallerNum = Number(targetString[j - 1])
          const diff = largerNum - smallerNum
          const nums = R.times(n => {
            return n + Number(smallerNum)
          }, diff + 1)

          nums.forEach(n => {
            results.push(sequentialYoubiChars + String(n))

            if (sequentialYoubiChars.length > 1) {
              // TODO:今の所このケースはないが
              console.log('要チェック')
            }
          })
          i++
        } else {
          break
        }
      }
    }
  }

  return R.uniq(results)
}

const getSequentialWeekdaysString = (str: string) => {
  let r = ''
  for (let i = 0; i < str.length; i++) {
    const char = str[i]
    if (isWeekDays(char)) {
      r += char
    } else {
      break
    }
  }
  return r
}
